<div class="cart-page" dir="rtl">

  <div class="cart-header">
    <h1 class="cart-title">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
        <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
        <line x1="3" y1="6" x2="21" y2="6"/>
        <path d="M16 10a4 4 0 01-8 0"/>
      </svg>
      עגלת הקניות
    </h1>
    <span class="cart-count">{{ items.length }} פריטים</span>
  </div>

  <!-- Empty state -->
  @if (items.length === 0) {
    <div class="empty-cart">
      <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#ccc" stroke-width="1.5">
        <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
        <line x1="3" y1="6" x2="21" y2="6"/>
        <path d="M16 10a4 4 0 01-8 0"/>
      </svg>
      <p>העגלה שלך ריקה</p>
      <a class="shop-link" routerLink="/">המשך לקנות</a>
    </div>
  }

  <!-- Cart content -->
  @if (items.length > 0) {
    <div class="cart-body">
      <div class="cart-items">
        @for (item of items; track item) {
          <div class="cart-item">
            <div class="item-img">
              @if (item.image) {
                <img [src]="item.image" [alt]="item.name" />
              }
              @if (!item.image) {
                <div class="img-placeholder">📦</div>
              }
            </div>
            <div class="item-info">
              <p class="item-name">{{ item.name }}</p>
              <p class="item-price">{{ formatPrice(item.price) }} לפריט</p>
            </div>
            <div class="item-qty">
              <button class="qty-btn" (click)="cart.setQty(item.id, item.qty - 1)">−</button>
              <span class="qty-val">{{ item.qty }}</span>
              <button class="qty-btn" (click)="cart.setQty(item.id, item.qty + 1)">+</button>
            </div>
            <div class="item-subtotal">{{ formatPrice(item.price * item.qty) }}</div>
            <button class="remove-btn" (click)="cart.remove(item.id)" title="הסר">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="3 6 5 6 21 6"/>
                <path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/>
                <path d="M10 11v6M14 11v6"/>
                <path d="M9 6V4h6v2"/>
              </svg>
            </button>
          </div>
        }
      </div>
      <!-- Summary -->
      <div class="cart-summary">
        <h3 class="summary-title">סיכום הזמנה</h3>
        @for (item of items; track item) {
          <div class="summary-row">
            <span class="sr-label">{{ item.name }} × {{ item.qty }}</span>
            <span class="sr-val">{{ formatPrice(item.price * item.qty) }}</span>
          </div>
        }
        <div class="summary-divider"></div>
        <div class="summary-total">
          <span>סה"כ לתשלום</span>
          <span class="total-price">{{ formatPrice(total) }}</span>
        </div>
        @if (checkoutError) {
          <p class="checkout-error">{{ checkoutError }}</p>
        }
        <button class="checkout-btn" [disabled]="checkoutLoading" (click)="checkout()">
          @if (checkoutLoading) {
            <span class="spinner"></span>
          }
          @if (!checkoutLoading) {
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
              <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
              <line x1="1" y1="10" x2="23" y2="10"/>
            </svg>
          }
          <span>{{ checkoutLoading ? 'מעבד...' : 'לתשלום' }}</span>
        </button>
        <button class="clear-btn" (click)="cart.clear()">נקה עגלה</button>
      </div>
    </div>
  }

</div>
